<template>
    <table class="driver-sync">
        <thead>
            <tr>
                <th>Source</th>
                <th>Last Modified</th>
                <th>Last Synced</th>
                <th width="130px">Sync Status</th>
                <th width="170px"></th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td><a :href="`/admin/drivers#${project.driver_source.id}`">{{ project.driver_source.name }}</a></td>
                <td>
                    <span v-if="driverUpdatedAt"
                        :title="localizeDate(driverUpdatedAt).format('dddd, MMMM Do YYYY, h:mm:ss a')">
                        {{ localizeDate(driverUpdatedAt).fromNow() }}
                    </span>
                    <span v-else>Unknown</span>
                </td>
                <td>
                    <span v-if="driverSyncedAt"
                        :title="localizeDate(driverSyncedAt).format('dddd, MMMM Do YYYY, h:mm:ss a')">
                        {{ localizeDate(driverSyncedAt).fromNow() }}
                    </span>
                    <span v-else>Unknown</span>
                </td>
                <td>
                    <span v-if="isSyncing"
                        title="Sync in progress..."
                        class="element-badge is--processing">
                        Syncing
                    </span>
                    <span v-else-if="isDriverOutdated"
                        class="element-badge is--error">
                        Out of Sync
                    </span>
                    <span v-else-if="driverSyncedAt"
                        class="element-badge is--active has--circle">
                        In Sync
                    </span>
                </td>
                <td>
                    <button
                        @click="onSyncPressed()"
                        :disabled="isSyncing"
                        class="element-button--secondary element-button"
                        type="button">
                        {{ syncButtonLabel }}
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import _ from 'lodash'
import Echo from '../helpers/echo'
import { MODEL_MAP } from '../helpers/builder'
import api from '../api/builder'
import { localizeDate } from '../helpers/util'
import moment from 'moment'

export default {
    props: {
        project: {
            type: Object
        }
    },
    data () {
        return {
            driverUpdatedAt: _.get(this.project, 'driver.updated_at'),
            driverSyncedAt: _.get(this.project, 'driver_synced_at'),
            isSyncing: false
        }
    },
    computed: {
        isDriverOutdated () {
            return moment(this.driverUpdatedAt).isAfter(this.driverSyncedAt)
        },
        syncButtonLabel () {
            return this.isSyncing ? 'Syncing to Portal...' : 'Sync to Portal'
        }
    },
    methods: {
        localizeDate,
        onSyncPressed () {
            this.syncToPortal()
        },
        async syncToPortal () {
            this.isSyncing = true
            let result = await api.syncDriver(this.project.id)
            console.log(result)
        },
        processNotification (notification) {
            console.log(notification)
            if (notification.progress === 1) {
                this.isSyncing = false
                this.driverSyncedAt = notification.model.driver_synced_at
            }
        }
    },
    created () {
        Echo.private(`${MODEL_MAP['project'].model}.${this.project.id}`)
            .notification((notification) => {
                this.processNotification(notification)
            })
    }
}
</script>
